import React from 'react';
import ReportPage from '../ReportChart/ReportPage';
import { Apis } from "services/api";
import { getOverdueServices } from "services/analytics";
import useChartColors from '../ReportChart/hooks/useChartColors';

const OverdueServicesReport = () => {
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  const { getAllColors } = useChartColors();

  const chartConfig = {
    id: 'overdue-services',
    title: `Overdue ${customCaptions?.servicePlural}`,
    fetchData: async (params) => {
      return await getOverdueServices(params);
    },
    allowedChartTypes: ['pie', 'vertical-bar'],
    defaultChartType: 'pie',
    axisConfig: {
      categoryAxis: { dataKey: 'label' },
      valueAxes: [{ 
        label: 'Count' 
      }]
    },
    series: [
      { 
        label: 'Count', 
        key: 'count', 
        showLegend: false,
        colors: getAllColors()
      }
    ],
    transformData: (response) => {
      return response?.data?.data;
    },
    viewData: '/app/services',
    filters: {
      timeframe: {
        allowCustomRange: true,
        defaultRange: 'show-all',
      },
      department: { multiSelect: true },
      model: true
    },
    drilldown: {
      axisConfig: {
        categoryAxis: { dataKey: 'label' },
        valueAxes: [{ 
          label: 'Count' 
        }]
      },
      series: [
        { 
          label: 'Count', 
          key: 'count', 
          showLegend: false,
          colors: getAllColors()
        }
      ],
      breadcrumbLabel: `${customCaptions?.model || 'Model'} Count`,
      getParams: (dataPoint) => {
        return {
          roleId: dataPoint.id,
          role: {
            id: dataPoint.id,
            name: dataPoint.name || "Show All"
          }
        };
      }
    }
  };

  return (
    <ReportPage 
      title={`Overdue ${customCaptions?.servicePlural}`}
      chartConfig={chartConfig}
    />
  );
};

export default OverdueServicesReport; 
